import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'

export const fetchPoolsBlockLimits = async () => {
  return []
}

export const fetchPoolsTotalStaking = async () => {
  return []
}

export const fetchPoolStakingLimit = async (): Promise<BigNumber> => {
  return BIG_ZERO
}

export const fetchPoolsStakingLimits = async (
  poolsWithStakingLimit: number[],
): Promise<{ [key: string]: BigNumber }> => {
  return {}
}
